(function () {
    'use strict';

    angular
        .module('elogbooksDirectives')
        .directive('elogsFileUploadDragAndDrop', (
            messenger,
            validationService,
            elbSettings,
            apiClient,
            disableSubmitService,
            mimeTypeMap,
            mimeTypeDetectorService,
            $timeout,
            $q,
            $injector,
            $translate
        ) => ({
            restrict: 'AE',
            templateUrl: '/modules/directives/form-elements/file-upload-drag-and-drop/file-upload-drag-and-drop.html',
            scope: {
                // Uploading result would go here - depends on $scope.returnObject or if it is $scope.allowMultiple
                model: '=ngModel',

                // If true - uploading files are in process (read access only)
                uploading: '=?',

                // It replaces the file name (only for single file upload allowMultiple=false)
                title: '=?',
                fileName: '=?',

                // All uploaded files data would go here (all raw details about files, including file content, types and upload to the server results)
                // more detailed $scope.model variable
                uploadedFiles: '=?',

                allowMultiple: '@',
                maxFilesUploading: '@', // The Maximum number of uploaded files in one time - 10 is default
                maxFiles: '@', // If allowMultiple, maximum number of uploaded files, no limit as a default

                // If 'allowMultiple' is on,
                // it would check if existing file with same name is already uploaded
                skipExistingFiles: '@', // Default true.

                // Display list of uploaded files below drag and drop area
                displayUploadedFilesList: '@', // Default false

                existingFiles: '=?',

                allowDeleteExistingFiles: '=?', // Default true.

                // events
                onFilesUploaded: '=?',

                // Can be a name of the group: 'image', 'document', 'text', 'pdf', 'world', 'csv', 'excel' see typesMap
                // or any file mime type. Multiple types separated by comma
                fileTypes: '@',

                // It would disable the form submit button if a file is not selected
                required: '=ngRequired',

                // If $scope.required - what is the minimum expected amount of files - default is 1
                minFilesToUpload: '@',
                disabled: '=?'
            },
            require: ['ngModel'],
            /**
             * Allowed directive attributes:
             *    id - It sets the form id attribute
             */
            link: function($scope, $element, attrs) {
                const Sentry = (() => {
                    try {
                        return $injector.get('Sentry') || null
                    } catch (e) {
                        return null;
                    }
                })();
                const allowMultiple = !!$scope.allowMultiple;
                const maxFilesUploading = allowMultiple ? Math.ceil($scope.maxFilesUploading || 10) || 10 : 1;
                const maxFiles = allowMultiple ? ($scope.maxFiles ? (Math.ceil($scope.maxFiles) || undefined) : undefined) : 1;
                const skipExistingFiles = $scope.skipExistingFiles === undefined ? true : !!$scope.skipExistingFiles;
                $scope.allowDeleteExistingFiles = $scope.allowDeleteExistingFiles === undefined ? true : !!$scope.allowDeleteExistingFiles;

                let submitButton = null;
                let fileTypes = $scope.fileTypes && $scope.fileTypes.length ?
                    $scope.fileTypes.split(',').map(type => type.toLowerCase().trim()) : [];
                let allowedTypes = [];
                $scope.minFilesToUpload = Math.ceil($scope.minFilesToUpload || 1) || 1;

                $scope.isUploading = false;
                $scope.uploadedFiles = [];
                $scope.error = false;
                $scope.isInvalid = false;
                $scope.uploadingFiles = []; // Uploading in process files
                let errorsTimeout = null;

                // Total uploading files progress
                $scope.progress = 0;
                $scope.totalSize = 0; // total bytes awaiting to upload
                $scope.uploaded = 0; // total uploaded bytes

                const fileDetailsTemplate = {
                    _uniqueId: null, // random generated string id
                    name: '', // original name
                    title: '',
                    filename: '',
                    extension: '',

                    // response from the elogs API
                    uploadResponse: null,

                    // response from cloud server
                    uploadCloudResponse: null,

                    // it would be saved in component model depends of $scope.returnObject
                    object: null,
                    resource: null,

                    // it would be changed into true if a file is currently uploading
                    isUploading: false,
                    isUploaded: false,

                    // it would be changed into true if a file is currently removing
                    isRemoving: false,

                    // JS File transfer object
                    file: null,

                    // If a file is already uploaded and don't need to move to the model
                    isExistingFile: false,

                    // Upload XMLHttpRequest object
                    request: null,
                    uploadProgress: 0,
                    totalSize: 0,
                    uploaded: 0,

                    uploadAborted: false,
                    abortUploading: () => {},

                    isImage: false,
                    isDocument: false,
                    isText: false,
                    isPdf: false,
                    isCsv: false,
                    isExcel: false,
                    isWord: false
                };
                const displayErrorToast = (() => {
                    let lastToastErrorMsg = null;

                    return (message, data, type = 'warning') => {
                        if (lastToastErrorMsg === message) {
                            return; // prevent displaying same message again
                        }

                        lastToastErrorMsg = message;
                        messenger[type](message, data);
                        $timeout(() => lastToastErrorMsg = null, 7500);
                    }
                })();

                const displayError = (error) => {
                    $scope.$applyAsync(() => {
                        $scope.error = {
                            ...error,
                            message: error.message || error.error,
                        }
                    });

                    if (errorsTimeout) {
                        $timeout.cancel(errorsTimeout);
                    }

                    // Hide errors after 10000ms
                    errorsTimeout = $timeout(() => {
                        $scope.$applyAsync(() => {
                            $scope.error = false;
                        });
                    }, 10000);
                }

                // Use system settings file type restrictions
                if (!fileTypes.length && elbSettings.getSetting('file_restrict').value) {
                    fileTypes = elbSettings.getSetting('file_allowed_types').value;
                }

                // Process fileTypes - map groups into a mime-types array
                for (const type of fileTypes) {
                    if (mimeTypeMap.hasOwnProperty(type)) {
                        allowedTypes = [...allowedTypes, ...mimeTypeMap[type]];
                    } else {
                        allowedTypes.push(type);
                    }
                }

                // create hidden form
                const form = document.createElement('form');

                form.setAttribute('method', 'post');
                form.setAttribute('enctype', 'multipart/form-data');
                form.setAttribute('class', 'file-upload-form');

                attrs.id && form.setAttribute('id', attrs.id);

                const fileInput = document.createElement('input');
                fileInput.setAttribute('name', 'file');
                fileInput.setAttribute('type', 'file');
                fileInput.setAttribute('class', 'file-upload-input');
                fileInput.setAttribute('hidden', 'hidden');

                allowMultiple && fileInput.setAttribute('multiple', 'multiple');
                allowedTypes.length && fileInput.setAttribute('accept', allowedTypes.join(','));

                form.appendChild(fileInput);
                document.body.appendChild(form);

                // Build existing files
                if (allowMultiple && $scope.existingFiles && $scope.existingFiles.length) {
                    for (const existingFile of $scope.existingFiles) {
                        if (angular.isString(existingFile)) {
                            const fileDetails = angular.extend({}, fileDetailsTemplate, {
                                _uniqueId: Math.random().toString(36).substr(2, 9),
                                name: existingFile,
                                isExistingFile: true,
                                canBeDeleted: true,
                                isUploaded: true,
                            });

                            $scope.uploadedFiles.push(fileDetails);
                        }

                        if (angular.isObject(existingFile)) {
                            const fileDetails = angular.extend({}, fileDetailsTemplate, {
                                _uniqueId: Math.random().toString(36).substr(2, 9),
                                name: existingFile.title,
                                isExistingFile: true,
                                isUploaded: true,
                                canBeDeleted: existingFile.canBeDeleted || true, 
                                href: existingFile?._links?.resource.href,
                                uploadResponse: {
                                    _links: {
                                        file: {
                                            href: existingFile?._links?.self?.href
                                        }
                                    }
                                }
                            });

                            $scope.uploadedFiles.push(fileDetails);
                        }
                    }
                }

                // Setup events
                const dropArea = $element.find('.drop-area')[0];

                const onDragOver = (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    e.effectAllowed = 'copy';

                    const types = e.dataTransfer?.types || [];

                    if (!types.includes('Files')) {
                        e.dataTransfer.dropEffect = 'none';
                        return;
                    }

                    dropArea.classList.add('drag-over');
                };

                dropArea.addEventListener('dragover', onDragOver);

                const onDragEnter = (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    e.effectAllowed = 'copy';

                    const types = e.dataTransfer?.types || [];

                    if (!types.includes('Files')) {
                        e.dataTransfer.dropEffect = 'none';
                        dropArea.classList.remove('drag-over');
                    }
                };

                dropArea.addEventListener('dragenter', onDragEnter);

                const onDragLeave = (e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    dropArea.classList.remove('drag-over');
                };

                dropArea.addEventListener('dragleave', onDragLeave);

                // Handle click on area - push file into input
                const onClick = (e) => {
                    e.preventDefault();

                    if ($scope.disabled) {
                        return;
                    }

                    // if single file upload - click event should be ignored
                    if ($scope.isUploading && !allowMultiple) {
                        return;
                    }

                    // it would display system file picker
                    fileInput.dispatchEvent(new PointerEvent('click'));
                };

                dropArea.addEventListener('click', onClick);

                // Handle drop files into area - push file into input
                const onDrop = (e) => {
                    e.preventDefault();
                    e.effectAllowed = 'copy';

                    if ($scope.disabled) {
                        return;
                    }

                    const types = e.dataTransfer?.types || [];

                    if (!types.includes('Files')) {
                        e.dataTransfer.dropEffect = 'none';
                        return;
                    }

                    const files = e.dataTransfer?.files || [];

                    if (files.length) {
                        handleFiles(files);
                    }
                };

                dropArea.addEventListener('drop', onDrop);

                const onFileChange = (e) => {
                    if ($scope.disabled) {
                        e.target.value = '';
                        return;
                    }

                    e.target?.files && e.target.files.length > 0 && handleFiles(e.target.files);
                    e.target.value = '';
                }

                // handle files
                fileInput.addEventListener('change', onFileChange);

                // Searching a main form element if exists
                const [$form, $formGroup, angularForm] = (() => {
                    let $form = null;
                    let $parent = $element.parent();
                    let $formGroup = null;
                    let angularForm = null;
                    let $parentScope = $scope.$parent;

                    do {
                        if ($parent.length && $parent[0].classList.contains('form-group')) {
                            $formGroup = $parent;
                            $parent = $parent.parent();
                            continue;
                        }

                        if ($parent.length && $parent[0].tagName.toLowerCase() === 'form') {
                            $form = $parent;
                        } else {
                            $parent = $parent.parent();
                        }
                    } while ($parent.length && $form === null);

                    if ($form) {
                        const formName = $form.attr('name');

                        if (formName) {
                            do {
                                if ($parentScope[formName] && $parentScope[formName].hasOwnProperty('$$controls')) {
                                    angularForm = $parentScope[formName];
                                } else {
                                    $parentScope = $parentScope.$parent;
                                }
                            } while ($parentScope !== null && angularForm === null)
                        }
                    }

                    return [$form, $formGroup, angularForm];
                })();

                // add form validation on submitting
                function onFormSubmit() {
                    if (!($form?.length && $formGroup?.length && angularForm) || !$form.$submitted) {
                        return;
                    }

                    if ($scope.required && ($scope.uploadedFiles < $scope.minFilesToUpload)) {
                        $scope.isInvalid = true;
                        $formGroup.addClass('has-error');

                        angularForm.$invalid = true;
                        angularForm.$valid = false;
                    } else {
                        $scope.isInvalid = false;
                        $formGroup.removeClass('has-error');
                    }
                }

                if ($form?.length && $formGroup?.length && angularForm) {
                    $form[0].addEventListener('submit', onFormSubmit);
                }

                // Add esc key support - to aboard uploading process
                const abortUploadingFiles = () => {
                    if ($scope.isUploading) {
                        $scope.isUploading = false;

                        for (const file of $scope.uploadingFiles) {
                            file.abortUploading();
                        }

                        $scope.uploadingFiles = [];

                        !!!$scope.$root.$$phase && $scope.$apply();
                        console.log('Upload has been canceled by the user.');
                    }
                }

                const escKeyListener = (event) => {
                    if (event.key === 'Escape' || event.keyCode === 27) {
                        abortUploadingFiles();
                    }
                };

                document.addEventListener('keydown', escKeyListener);

                // On component destruction - free the browser memory!
                $scope.$on('$destroy', () => {
                    form.remove();

                    dropArea.removeEventListener('dragover', onDragOver);
                    dropArea.removeEventListener('dragenter', onDragEnter);
                    dropArea.removeEventListener('dragleave', onDragLeave);
                    dropArea.removeEventListener('click', onClick);
                    dropArea.removeEventListener('drop', onDrop);
                    document.removeEventListener('keydown', escKeyListener);

                    if ($form?.length && $formGroup?.length && angularForm) {
                        $form[0].removeEventListener('submit', onFormSubmit);
                    }
                });

                // Update uploading status
                $scope.$watch('isUploading', (isUploading) => $scope.uploading = isUploading);

                const filterExistingFiles = (files) => {
                    if (allowMultiple && skipExistingFiles && files.length && $scope.uploadedFiles.length) {
                        const newFilesList = [];

                        for (const file of files) {
                            let fileExist = false;
                            for (const existingFile of $scope.uploadedFiles) {
                                if (file.name === existingFile.name) {
                                    fileExist = true;
                                    break;
                                }
                            }

                            if (fileExist) {
                                displayError({type: 'warning', message: 'DRAG_AND_DROP_FILES_FILE_EXIST', file } );
                                displayErrorToast('DRAG_AND_DROP_FILES_FILE_EXIST_FILE_NAME', { file });
                            } else {
                                newFilesList.push(file)
                            }
                        }

                        files = newFilesList;
                    }

                    return files;
                }

                const validateTotalFilesCount = (files) => {
                    const totalFiles = $scope.uploadedFiles.length + files.length;

                    if (totalFiles && maxFiles && totalFiles > maxFiles) {
                        displayErrorToast('FILES_LIMIT_REACHED', {
                            maxAmount: maxFiles
                        });

                        displayError({
                            message: 'FILES_LIMIT_REACHED',
                            type: 'warning',
                            maxAmount: maxFiles
                        });

                        return false;
                    }

                    return true;
                }

                const validateUploadFilesCount = (files) => {
                    const totalUploadingFiles = (() => {
                        let count = files.length;

                        for (const file of $scope.uploadedFiles) {
                            if (file.isUploading) {
                                count++;
                            }
                        }

                        return count;
                    })();

                    if (totalUploadingFiles > maxFilesUploading) {
                        displayErrorToast('FILE_UPLOAD_LIMIT_REACHED', {
                            filesAmount: files.length,
                            maxAmount: maxFilesUploading
                        });

                        displayError({
                            message: 'FILE_UPLOAD_LIMIT_REACHED',
                            type: 'warning',
                            filesAmount: files.length,
                            maxAmount: maxFilesUploading
                        });

                        return false;
                    }

                    return true;
                }

                const fileUploadError = (e, files) => {
                    $scope.$applyAsync(() => {
                        if (!(!!$scope.required && (files.length < $scope.minFilesToUpload))) {
                            submitButton = disableSubmitService.enableSubmit(submitButton);
                        }

                        if (e.hasOwnProperty('file')) {
                            $scope.uploadingFiles = $scope.uploadingFiles.filter(f => e.file._uniqueId !== f._uniqueId);
                        }

                        $scope.isUploading = !!$scope.uploadingFiles.length;
                    });

                    if (e.hasOwnProperty('file')) {
                        e.file.isUploading = false;
                        e.file.isUploaded = false;

                        // Display warning
                        if (e.hasOwnProperty('error')) {
                            displayError(e);

                            let messengerData = {}
                            for (const key of Object.keys(e)) {
                                if (e.hasOwnProperty(key)) {
                                    messengerData[key] = e[key];
                                }
                            }

                            if (e.type === 'warning') {
                                displayErrorToast(e.error, messengerData);
                            } else if (e.type === 'danger') {
                                displayErrorToast(e.error, messengerData, 'error');
                                if (Sentry) {
                                    reportFileUploadError(e, e.error);
                                } else {
                                    console.error(e.error, e);
                                }
                            }
                        } else {
                            displayErrorToast('FILE_UPLOAD_ERROR', {}, 'error');
                            displayError({ message: 'FILE_UPLOAD_ERROR', type: 'danger' });
                            if (Sentry) {
                                reportFileUploadError(e);
                            } else {
                                console.error(e.error, e);
                            }
                        }

                        // Remove file from uploading array - and remove file from elogs - if file was already created
                        $scope.delete(e.file);

                        $scope.$applyAsync(() => {
                            const uploadingFileIndex = $scope.uploadingFiles.findIndex(f => f._uniqueId === e.file._uniqueId);
                            (uploadingFileIndex !== -1) && $scope.uploadingFiles.splice(uploadingFileIndex, 1);
                        });
                    } else {
                        // On any different error
                        if (Sentry) {
                            reportFileUploadError(e);
                        } else {
                            console.error(e);
                        }
                    }
                }

                function reportFileUploadError(errorDetails, message) {
                    Sentry.withScope(scope => {
                        scope.setExtra('fileDetails.name', errorDetails?.file?.name);
                        scope.setExtra('fileDetails.filename', errorDetails?.file?.filename);
                        scope.setExtra('fileDetails.type', errorDetails?.file?.file?.type);
                        scope.setExtra('fileDetails.size', errorDetails?.file?.file?.size);
                        scope.setExtra('fileDetails.extension', errorDetails?.file?.extension);

                        let details;

                        try {
                            details = JSON.stringify(errorDetails);
                        } catch (e) {
                            details = Object.prototype.toString.call(errorDetails);
                        }

                        scope.setContext('errorDetails', { details });

                        Sentry.captureMessage(message || $translate.instant('FILE_UPLOAD_ERROR'), 'error');
                    });
                }

                const handleDisablingSubmitBtnAndFormValidation = () => {
                    // turn off uploading status and enable form submitting only if all files are uploaded

                    $scope.$applyAsync(() => {
                        $scope.isUploading = !!$scope.uploadingFiles.length;

                        if ($scope.disabled) {
                            return;
                        }

                        const isMinimumFilesUploaded = !(!!$scope.required && ($scope.uploadedFiles < $scope.minFilesToUpload));

                        if ($scope.isInvalid && !!$formGroup?.length && ($scope.uploadedFiles.length >= $scope.minFilesToUpload)) {
                            $scope.isInvalid = false;
                            $formGroup.removeClass('has-error');
                        }

                        // set angular form dirty
                        if ($form?.length && angularForm) {
                            if (!!!$form.attr('data-ignore-dirty') && $scope.uploadedFiles.length) {
                                angularForm.$dirty = true;
                                $form.addClass('ng-dirty');
                            } else {
                                angularForm.$dirty = false;
                                $form.removeClass('ng-dirty');
                            }
                        }

                        // submit btn disable/enable
                        if (isMinimumFilesUploaded && !$scope.isUploading) {
                            submitButton = disableSubmitService.enableSubmit(submitButton);
                        } else {
                            submitButton = disableSubmitService.disableSubmit(submitButton);
                        }
                    });
                }

                const startUploading = (files) => {
                    submitButton = disableSubmitService.disableSubmit(submitButton);
                    $scope.$applyAsync(() => $scope.isUploading = true);

                    const requests = [];
                    const processedFiles = [];
                    $scope.error = false;

                    for (const file of files) {
                        // Push promise into promises array
                        const deferred = $q.defer();
                        requests.push(deferred.promise);

                        // Process file upload
                        processFile(file).then(({file}) => {
                            $scope.uploadingFiles.push(file);

                            createFileEntity(file).then(() => {
                                if (file.uploadAborted) {
                                    deferred.resolve();
                                } else {
                                    uploadToBucket(file).then(() => {
                                        file.isUploaded = true;
                                        file.isUploading = false;

                                        const uploadingFileIndex = $scope.uploadingFiles.findIndex(f => f._uniqueId === file._uniqueId);
                                        (uploadingFileIndex !== -1) && $scope.uploadingFiles.splice(uploadingFileIndex, 1);

                                        // Reset uploading progress
                                        if (!$scope.uploadingFiles.length) {
                                            $scope.totalSize = 0;
                                            $scope.uploaded = 0;
                                            $scope.progress = 0;
                                        }

                                        processedFiles.push(file);
                                        deferred.resolve();
                                    }).catch((e) => { fileUploadError(e, files); deferred.resolve() });
                                }
                            }).catch((e) => { fileUploadError(e, files); deferred.resolve() });
                        }).catch((e) => { fileUploadError(e, files); deferred.resolve() });
                    }

                    $q.all(requests).then(() => {
                        // append 'resource' and 'object' to the files
                        processedFiles.map((file) => {
                            file.resource = file.uploadResponse._links.resource;
                            file.object = {
                                _links: {
                                    file: file.uploadResponse._links.file,
                                    resource: file.uploadResponse._links.resource
                                },
                                title: file.title,
                                filename: file.filename,
                                type: file.file.type,
                                href: file.uploadResponse._links.resource.href
                            };

                            return file;
                        });

                        if (allowMultiple && processedFiles.length) {
                            const model = [...$scope.model];

                            for (const file of processedFiles) {
                                // Skip aborted upload files
                                if (file.uploadAborted) {
                                    continue;
                                }

                                model.push(
                                    file.object ?? file.resource
                                )
                            }

                            $scope.$applyAsync(() => $scope.model = model);
                        } else if (processedFiles.length) {
                            const file = processedFiles[0];

                            if (!file.uploadAborted) {
                                $scope.$applyAsync($scope.model = file.object ?? file.resource);
                            }
                        }

                        handleDisablingSubmitBtnAndFormValidation();

                        $scope.onFilesUploaded && $scope.onFilesUploaded(processedFiles, $scope.uploadedFiles);
                    });
                }

                // Process added files - update scope, loading, uploading to the server and clouds
                function handleFiles(files) {
                    // Multiple files uploader can upload new files during uploading any other files in the background
                    // Single file uploader can only upload 1 file - so uploading can be disabled
                    if ($scope.isUploading && !allowMultiple) {
                        return;
                    }

                    dropArea.classList.remove('drag-over');

                    if (!files || !files.length) {
                        displayError({ message: 'NO_FILES_TO_UPLOAD', type: 'warning' });
                        return;
                    }

                    // remove existing files
                    files = filterExistingFiles(files);

                    // Validate total files and uploaded files count
                    if (!validateTotalFilesCount(files) || !validateUploadFilesCount(files)) {
                        return;
                    }

                    startUploading(files);
                }

                // Process file details, validate file
                function processFile(file) {
                    const deferred = $q.defer();

                    const fileDetails = angular.extend({}, fileDetailsTemplate, {
                        _uniqueId: Math.random().toString(36).substr(2, 9),
                        name: file.name,
                        isImage: mimeTypeMap.image.includes(file.type),
                        isDocument: mimeTypeMap.document.includes(file.type),
                        isText: mimeTypeMap.text.includes(file.type),
                        isPdf: mimeTypeMap.pdf.includes(file.type),
                        isCsv: mimeTypeMap.csv.includes(file.type),
                        isExcel: mimeTypeMap.excel.includes(file.type),
                        isWord: mimeTypeMap.word.includes(file.type),
                        file,
                        detectedMimeType: null, // Will be set after detection
                    });

                    if (!validationService.isFileNameValid(file.name)) {
                        deferred.reject({error: 'INVALID_FILE_NAME', type: 'warning', file: fileDetails});
                        return deferred.promise;
                    }

                    if (!validationService.isFileSizeValid(file.size)) {
                        deferred.reject({error: 'FILE_TOO_LARGE', type: 'warning', file: fileDetails});
                        return deferred.promise;
                    }

                    // set file names
                    fileDetails.title = file.name.split(/(\\|\/)/g).pop();
                    fileDetails.filename = fileDetails.title;
                    fileDetails.extension = fileDetails.title.split('.').pop();

                    // overwrite file names - only for singe file upload
                    if (!allowMultiple) {
                        if ($scope.fileName) {
                            fileDetails.filename = $scope.fileName + '.' + fileDetails.extension;
                        }

                        if ($scope.title) {
                            fileDetails.title = $scope.title.trim();
                        }
                    }

                    // Add file uploading abort
                    fileDetails.abortUploading = () => {
                        fileDetails.uploadAborted = true;
                        fileDetails.isUploading = false;
                        fileDetails.isUploaded = false;
                        fileDetails.uploadProgress = 0;
                        fileDetails.totalSize = 0;
                        fileDetails.uploaded = 0;

                        if (fileDetails.request) {
                            fileDetails.request.abort();
                        }

                        // remove file from elogs
                        // if file wasn't upload to elogs - it would only remove file details from the screen
                        $scope.delete(fileDetails);
                    };

                    // Detect actual MIME type using our service
                    mimeTypeDetectorService.detectMimeType(file).then(detectedMimeType => {
                        fileDetails.detectedMimeType = detectedMimeType;

                        console.log('File `'+file.name+'` Detected MIME type: ', detectedMimeType);

                        // validate file type
                        if (allowedTypes.length && !allowedTypes.some(type => {
                            // Check if the detected MIME type is in the allowed types
                            // or if any of the allowed types for this extension includes the detected type
                            const extension = file.name.split('.').pop().toLowerCase();
                            const allowedTypesForExtension = mimeTypeMap[extension] || [];
                            return type === detectedMimeType || allowedTypesForExtension.includes(type);
                        })) {
                            deferred.reject({
                                error: 'INCORRECT_FILE_TYPE_ALLOWED_TYPES',
                                type: 'warning',
                                file: fileDetails,
                                allowedTypes: fileTypes,
                                allowedTypesJoined: fileTypes.join(', ')
                            });
                            return;
                        }

                        // Continue with file processing
                        $scope.$applyAsync(() => {
                            fileDetails.isUploading = true;
                            $scope.uploadedFiles = [...$scope.uploadedFiles, fileDetails];
                        });

                        deferred.resolve({file: fileDetails});
                    });

                    return deferred.promise;
                }

                function createFileEntity(fileDetails) {
                    const deferred = $q.defer();

                    apiClient.create('/files', {
                        title: fileDetails.title,
                        filename: fileDetails.filename,
                        type: fileDetails.detectedMimeType,
                        size: fileDetails.file.size
                    }).then((data) => {
                        if (data && data.hasOwnProperty('_links')) {
                            fileDetails.uploadResponse = data;
                        }

                        if (fileDetails.uploadAborted) {
                            fileDetails.abortUploading();
                            deferred.resolve();
                            return;
                        }

                        if (data === false) {
                            const errorResponse = apiClient.getLastError();
                            const msg = errorResponse?.data?.[0]?.message || false;

                            if (msg && (msg === 'FILE_TYPE_DISALLOWED' || msg === 'FILE_EXTENSION_UNKNOWN')) {
                                messenger.clear($translate.instant(msg));

                                deferred.reject({
                                    error: 'INCORRECT_FILE_TYPE_ALLOWED_TYPES',
                                    type: 'warning',
                                    file: fileDetails,
                                    allowedTypes: fileTypes,
                                    allowedTypesJoined: fileTypes.join(', ')
                                });

                                return deferred.promise;
                            }

                            if (msg === 'FILE_TOO_LARGE') {
                                messenger.clear($translate.instant(msg));

                                deferred.reject({error: 'FILE_TOO_LARGE', type: 'warning', file: fileDetails});

                                return deferred.promise;
                            }
                        }

                        fileDetails.uploadResponse ? deferred.resolve() : deferred.reject({file: fileDetails});
                    }).catch(() => {
                        deferred.reject({file: fileDetails, error: 'FILE_UPLOAD_ERROR', type: 'danger'});
                    });

                    return deferred.promise;
                }

                function uploadToBucket(fileDetails) {
                    const deferred = $q.defer();

                    if (!fileDetails.uploadResponse) {
                        console.error('File is not uploaded to elogs');
                        deferred.reject({file: fileDetails, error: 'FILE_UPLOAD_ERROR', type: 'danger'});
                        return deferred.promise;
                    }

                    const data = new FormData();
                    const request = new XMLHttpRequest();
                    fileDetails.request = request;

                    const onRequestError = (response) => {
                        console.error('Error sending file to the google cloud');
                    };

                    for (const name in fileDetails.uploadResponse.policy) {
                        if (!fileDetails.uploadResponse.policy.hasOwnProperty(name)) {
                            continue;
                        }

                        data.append(name, fileDetails.uploadResponse.policy[name]);
                    }

                    data.append('file', fileDetails.file);

                    request.open('POST', fileDetails.uploadResponse.getLink('remote'));

                    request.onload = function() {
                        if (this.status === 200 && this.response.length) {
                            fileDetails.uploadCloudResponse = JSON.parse(this.response) || {};

                            if (!fileDetails.uploadCloudResponse.hasOwnProperty('url')) {
                                onRequestError(this);
                                deferred.reject({file: fileDetails});
                            } else {
                                deferred.resolve();
                            }
                        } else {
                            onRequestError(this);
                            deferred.reject({file: fileDetails});
                        }
                    };

                    request.onabort = function() {
                        console.log('File upload aborted', fileDetails);
                        deferred.resolve();
                    }

                    request.onerror = function() {
                        onRequestError(this);
                        deferred.reject({file: fileDetails, error: 'FILE_UPLOAD_ERROR', type: 'danger'});
                    };

                    request.upload.onprogress = function(e) {
                        $scope.$applyAsync(() => {
                            fileDetails.uploadProgress = e.total ? Math.round(e.loaded / e.total * 100) : 0;
                            fileDetails.totalSize = e.total;
                            fileDetails.uploaded = e.loaded;

                            $scope.totalSize = $scope.uploadingFiles.map(f => f.totalSize).reduce((a, b) => a + b, 0);
                            $scope.uploaded = $scope.uploadingFiles.map(f => f.uploaded).reduce((a, b) => a + b, 0);
                            $scope.progress = $scope.totalSize ? Math.round($scope.uploaded / $scope.totalSize * 100) : 0;
                        });
                    };

                    request.send(data);

                    return deferred.promise;
                }

                const removeFileFromScope = (fileToRemove) => {
                    $scope.$applyAsync(() => {
                        // Remove file from uploaded file list
                        const uploadedFileIndex = $scope.uploadedFiles.findIndex(f => f._uniqueId === fileToRemove._uniqueId);
                        (uploadedFileIndex !== -1) && $scope.uploadedFiles.splice(uploadedFileIndex, 1);

                        // update model
                        let newModel = allowMultiple ? [] : null;

                        for (const file of $scope.uploadedFiles) {
                            if (allowMultiple) {
                                if (file.object || file.resource) {
                                    newModel.push(
                                        file.object ?? file.resource
                                    );
                                } else {
                                    newModel.push(file);
                                }
                            } else {
                                newModel = file.object ?? file.resource;
                                break;
                            }
                        }

                        $scope.model = newModel;
                    });
                };

                $scope.delete = (file) => {
                    const deferred = $q.defer();

                    const deleteUrl = file?.uploadResponse?._links?.delete?.href;

                    if (!deleteUrl) {
                        removeFileFromScope(file);
                        deferred.resolve();
                        return deferred.promise;
                    }

                    $scope.$applyAsync(() => file.isRemoving = true);

                    apiClient.delete(deleteUrl).then(() => {
                        removeFileFromScope(file);
                        deferred.resolve();
                    }).catch((e) => {
                        removeFileFromScope(file);
                        console.error('Error deleting file from elogs: ', file, e);
                        deferred.reject();
                    });

                    return deferred.promise;
                }

                $scope.abortUploading = (e) => {
                    if (e.target.classList.contains('abort-btn')) {
                        e.preventDefault();
                        e.stopPropagation();
                        abortUploadingFiles();
                    }
                };

                $scope.abortSingleFileUploading = (file) => {
                    file.abortUploading();

                    $scope.$applyAsync(() => {
                        // Remove file from uploading list
                        const uploadingFileIndex = $scope.uploadingFiles.findIndex(f => f._uniqueId === file._uniqueId);
                        (uploadingFileIndex !== -1) && $scope.uploadingFiles.splice(uploadingFileIndex, 1);

                        if ($scope.isUploading && $scope.uploadingFiles.length === 0) {
                            $scope.isUploading = false;
                        }
                    })
                }
            }
        }))
})();
